const ACCORDION_SIZES = {
    S16: 16,
    S24: 24,
    S32: 32,
};
const CONTENT_SIZES = {
    S16: 16,
    S20: 20,
    S24: 24,
    S28: 28,
};
const CONTAINER_SIZES = {
    S36: 36,
    S44: 44,
    S52: 52,
    S60: 60,
};
const FONT_SIZES = {
    S8: 8,
    S10: 10,
    S12: 12,
    S14: 14,
    S16: 16,
    S20: 20,
};
const STAR_SIZES = {
    ...CONTENT_SIZES,
    S32: 32,
    S36: 36,
};

export { ACCORDION_SIZES, CONTAINER_SIZES, CONTENT_SIZES, FONT_SIZES, STAR_SIZES };
//# sourceMappingURL=sizes.js.map
